import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { Map, Camera, Music, Sparkles } from 'lucide-react';
export function EventVenues() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} className="min-h-screen bg-white" data-id="element-428">
      <Header data-id="element-429" />

      <main className="pt-32 pb-24" data-id="element-430">
        <section className="max-w-7xl mx-auto px-6 mb-32 text-center" data-id="element-431">
          <span className="section-overline" data-id="element-432">Partnerships</span>
          <h1 className="text-[#4A0E0E] mb-8" data-id="element-433">Distinctive Spaces</h1>
          <p className="text-[#2C2C2C]/60 max-w-3xl mx-auto text-lg" data-id="element-434">
            We provide sophisticated wine hospitality for the region's most
            distinctive event spaces, ensuring every gathering is marked by
            excellence.
          </p>
        </section>

        <section className="max-w-7xl mx-auto px-6 mb-32" data-id="element-435">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-436">
            <div className="md:col-span-2 rounded-3xl overflow-hidden h-[500px]" data-id="element-437">
              <img src="https://cdn.magicpatterns.com/uploads/vjL8XmfAru8DqVvkiBNSGa/pexels-araujo-5004027.jpg" alt="Event Venue" className="w-full h-full object-cover" data-id="element-438" />
            </div>
            <div className="bg-[#FDFCF0] rounded-3xl p-12 flex flex-col justify-center border border-[#E6D5B8]/50" data-id="element-439">
              <h2 className="text-3xl font-serif text-[#4A0E0E] mb-6" data-id="element-440">
                Versatile Hospitality
              </h2>
              <p className="text-[#2C2C2C]/70 leading-relaxed" data-id="element-441">
                Whether it's a historic estate, a modern gallery, or an outdoor
                pavilion, our team adapts to the unique character of each venue
                to deliver seamless service.
              </p>
            </div>
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-6 mb-32" data-id="element-442">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-443">
            {[{
            icon: <Camera data-id="element-444" />,
            title: 'Visual Excellence',
            desc: "Stunning setups that complement the venue's aesthetic."
          }, {
            icon: <Music data-id="element-445" />,
            title: 'Atmosphere',
            desc: 'Curated soundscapes and lighting for every event.'
          }, {
            icon: <Sparkles data-id="element-446" />,
            title: 'Bespoke Service',
            desc: 'White-glove hospitality tailored to your occasion.'
          }, {
            icon: <Map data-id="element-447" />,
            title: 'Venue Scouting',
            desc: 'Assistance in finding the perfect space for your needs.'
          }].map((item, idx) => <div key={idx} className="text-center group" data-id="element-448">
                <div className="w-16 h-16 bg-[#FDFCF0] rounded-2xl flex items-center justify-center text-[#D4AF37] mx-auto mb-6 group-hover:bg-[#4A0E0E] group-hover:text-white transition-colors duration-500" data-id="element-449">
                  {item.icon}
                </div>
                <h4 className="text-xl font-serif text-[#4A0E0E] mb-4" data-id="element-450">
                  {item.title}
                </h4>
                <p className="text-[#2C2C2C]/60 text-sm leading-relaxed" data-id="element-451">
                  {item.desc}
                </p>
              </div>)}
          </div>
        </section>
      </main>

      <Footer data-id="element-452" />
    </motion.div>;
}